import { render, staticRenderFns } from "./featuredItemsHeader.vue?vue&type=template&id=1d1a8c6b&scoped=true&"
import script from "./featuredItemsHeader.vue?vue&type=script&lang=js&"
export * from "./featuredItemsHeader.vue?vue&type=script&lang=js&"
import style0 from "./featuredItemsHeader.vue?vue&type=style&index=0&id=1d1a8c6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1a8c6b",
  null
  
)

export default component.exports